import Paper from '@/components/core/paper/Paper';
import { templateDetails, templateChange } from '../../../api/product';
import config from './publicProperty.js';
import uploadPictures from '../../../components/productComponent/newUploadBtn';
import UploadPlayer from '../../../components/productComponent/newUploadPlayer';
import { mapGetters } from 'vuex';
export default {
    name: 'publicproperty',
    data() {
        return {
            rowInf: '',
            saveBlock: false,
            canCheck: false,
            config: config,
            videoName: '',
            id: '',
            videoArr: [],
            pictureArr: [],
            playNumCheck: true,
            pictureCheck: true,
            checkNames: true,
            rules: {
                templateCode: [
                    { required: true, message: this.$translate('lang.EXC202103010001', { defaultText: '请输入模板编码' }), trigger: 'blur' },
                    { pattern: /^[a-zA-Z0-9]{6,20}$/, message: this.$translate('lang.EXC202103010002', { defaultText: '模板编码必须为6~20位的数字或字母组成!' }) }
                ],
                templateName: [{ required: true, message: this.$translate('lang.EXC202103010003', { defaultText: '请输入模板名称' }), trigger: 'blur' }],
                templateDescription: [{ required: true, message: this.$translate('lang.EXC202103010004', { defaultText: '请输入模板说明' }), trigger: 'blur' }]
            },
            main: {
                id: '',
                templateCode: '',
                templateName: '',
                templateDescription: '',
                status: 'Y',
                version: '',
                attributeList: []
            },
            copyMain: {
                id: '',
                templateCode: '',
                templateName: '',
                templateDescription: '',
                status: 'Y',
                version: '',
                attributeList: []
            },
            newDefault: [
                {
                    name: this.$translate('lang.E3202103010001', { defaultText: '品牌' }),
                    attributeType: '0'
                }, {
                    name: this.$translate('lang.E3202103010002', { defaultText: '产地' }),
                    attributeType: '0'
                },
                {
                    name: this.$translate('lang.E3202103010003', { defaultText: '毛重(KG)' }),
                    attributeType: '1'
                }
            ],
            tenantCode: '',
            sendArray: []
        };
    },
    computed: {
        ...mapGetters(['user', 'currentTenant'])
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        checkEng($index, attributeValue) {
            const regs = /^[a-zA-Z]*$/g;
            if (regs.test(attributeValue)) {
                this.main.attributeList[$index].attributeValue = '';
                this.$message.warning(this.$translate('lang.EXC202103010005', { defaultText: '请输入正确的数字类型（小数点后两位）' }));
            }
        },
        checkNumber($index, attributeValue) {
            const reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/g;
            const numberAnswer = reg.test(attributeValue);
            if (numberAnswer) {
            } else {
                this.main.attributeList[$index].attributeValue = '';
                this.$message.warning(this.$translate('lang.EXC202103010005', { defaultText: '请输入正确的数字类型（小数点后两位）' }));
            }
        },
        channelInputLimit(e) {
            const key = e.key;
            // 不允许输入'e'和'.'
            if (key === '——' || key === '-' || key === 'e' || key === 'E') {
                e.returnValue = false;
                return false;
            }
            return true;
        },
        deleteRow($index, row) {
            this.$confirm(this.$translate('lang.EXC202103010006', { defaultText: '此操作将删除该条模板, 是否继续?' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                })
                .then(() => {
                    this.main.attributeList.splice($index, 1);
                    this.throughArray();
                    this.$message.success(this.$translate('lang.EXC202102230001', { defaultText: '删除成功!' }));
                }).catch(() => {
                    this.throughArray();
                });
        },
        // 新增默认属性
        newDefaultPush() {
            this.newDefault.map(item => {
                this.main.attributeList.push({
                    id: '',
                    version: '',
                    attributeName: item.name,
                    attributeType: item.attributeType,
                    required: 'Y',
                    effect: 'Y',
                    display: 'Y',
                    attributeValue: ''
                });
            });
        },
        // 切割图片
        screenCutPicture(attributeList) {
            attributeList.map(item => {
                if (+item.attributeType === 2) {
                    if (item.attributeValue) {
                        item.showPicture = item.attributeValue;
                        item.showPicture = item.showPicture.split(',');

                        for (var i = 0; i < item.showPicture.length; i++) {
                            if (item.showPicture[i] === 'null') {
                                item.showPicture.splice(i, 1);
                            }
                            if (item.showPicture[i] === '') {
                                item.showPicture.splice(i, 1);
                            }
                        }
                    }
                } else if (+item.attributeType === 3) {
                    if (item.attributeValue) {
                        const videoRules = (item.attributeValue).lastIndexOf('\/');
                        (item.attributeValue) = (item.attributeValue).substring(videoRules + 1, item.attributeValue.length);
                        item.attributeValue = item.attributeValue.split(',')[0];
                        if (item.attributeValue === 'null') {
                            item.attributeValue = '';
                        }
                    }
                }
            });
        },
        // 获取图片数组，切割
        cutPicture() {
            this.sendArray = JSON.parse(JSON.stringify(this.main.attributeList));
            let showList = [];
            let imgPath = '';
            for (let i = 0; i < this.sendArray.length; i++) {
                if (this.sendArray[i].attributeType === '2') {
                    showList = this.sendArray[i].showPicture;
                    for (let j = 0; j < showList.length; j++) {
                        const rules = showList[j].lastIndexOf('\/');
                        showList[j] = showList[j].substring(rules + 1, showList[j].length);
                    }
                    for (let z = 0; z < showList.length; z++) {
                        imgPath += showList[z] + ',';
                    }
                    this.sendArray[i].attributeValue = imgPath;
                }
                delete this.sendArray[i].index;
                delete this.sendArray[i].showPicture;
            }
        },
        // 删除图片
        deletePicture(index) {
            this.$confirm(this.$translate('lang.EXC202103010007', { defaultText: '是否删除该图片, 是否继续?' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                })
                .then(() => {
                    this.$message.success(this.$translate('lang.EXC202102230001', { defaultText: '删除成功!' }));
                    this.main.attributeList[this.rowInf].showPicture.splice(index, 1);
                })
                .catch(() => {
                });
        },
        // 将图片路径存储
        pushImg(row) {
            this.main.attributeList[this.rowInf].showPicture.push(row);
        },
        // 将视频路径存储
        pushUrl(row) {
            this.main.attributeList.map(item => {
                if (item.attributeType === '3') {
                    item.attributeValue = row;
                    item.editing = false;
                }
            });
        },
        // 清楚当行视频路径
        clearVideo(row) {
            this.$confirm(this.$translate('lang.EXC202103010008', { defaultText: '是否删除该路径, 是否继续?' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                })
                .then(() => {
                    row.attributeValue = '';
                })
                .catch(() => {
                });
        },
        // 下拉框值变动时触发
        currStationChange(val) {
            val.attributeValue = '';
            this.throughArray();
        },
        // 便利数组
        throughArray() {
            this.main.attributeList.map(item => {
                if (item.attributeType === '3') {
                    this.videoArr.push(item.attributeType);
                }
                if (item.attributeType === '2') {
                    this.pictureArr.push(item.attributeType);
                }
            });
            if (this.videoArr.length > 1) {
                this.$message.warning(this.$translate('lang.EXC202103010009', { defaultText: '视频属性，只可以添加一条' }));
                this.videoArr.length = 0;
                this.playNumCheck = false;
            } else {
                this.playNumCheck = true;
                this.videoArr.length = 0;
            }
            if (this.pictureArr.length > 1) {
                this.$message.warning(this.$translate('lang.EXC202103010010', { defaultText: '图片属性，只可以添加一条' }));
                this.pictureArr.length = 0;
                this.pictureCheck = false;
            } else {
                this.pictureCheck = true;
                this.pictureArr.length = 0;
            }
        },
        // 点击当前行，可修改
        check(row) {
            this.rowInf = row.index;
            this.$set(row, 'editing', true);
        },
        // 点击取消，跳转回产品模板页面
        goProduct() {
            this.$eventBus.$emit('closeTag', this.$route);
            this.$router.go(-1);
        },
        // 新增一条模板数据，当前条数最多为50
        addTemp() {
            this.throughArray();
            if (this.playNumCheck === true && this.pictureCheck === true) {
                if (this.main.attributeList.length > 51) {
                    this.$message.warning(this.$translate('lang.EXC202103010011', { defaultText: '当前允许，最多50条记录' }));
                } else {
                    this.main.attributeList = this.main.attributeList || [];
                    this.main.attributeList.push({
                        id: null,
                        version: null,
                        attributeName: '',
                        attributeType: '0',
                        required: 'Y',
                        effect: 'Y',
                        display: 'Y',
                        attributeValue: '',
                        editing: true,
                        editings: true,
                        showPicture: []
                    });
                    this.$nextTick(() => {
                        this.$refs.tables.bodyWrapper.scrollTop = this.$refs.tables.bodyWrapper.scrollHeight;
                    });
                }
            } else {
                this.$message.warning(this.$translate('lang.EXC202103010012', { defaultText: '图片/视频属性值只允许添加一条' }));
            }
        },
        handleEdit($index, row) {
            this.$set(this.tempList[$index], 'editing', true);
        },
        // 保存
        handleSave($index, row) {
            this.$set(this.tempList[$index], 'editing', false);
        },
        // 取消
        handleCancel($index, row) {
            this.$set(this.tempList[$index], 'editing', false);
        },
        // 判断属性名称是否为空
        checkName() {
            this.main.attributeList.map(item => {
                if (!item.attributeName) {
                    this.checkNames = false;
                }
            });
        },
        // 保存，跳转会产品模板页面
        requestSend() {
            this.checkName();
            if (this.playNumCheck === true && this.pictureCheck === true && this.checkNames === true) {
                this.cutPicture();
                const pushData = {
                    id: this.main.id,
                    attributeList: this.sendArray,
                    status: this.main.status,
                    templateCode: this.main.templateCode,
                    templateDescription: this.main.templateDescription,
                    templateName: this.main.templateName,
                    version: this.main.version
                };

                this.$refs.publicProperty.validate((valid) => {
                    if (valid) {
                        this.saveBlock = true;
                        templateChange(pushData).then(res => {
                            if (res.code === '0') {
                                this.$message.success(this.$translate('lang.EXC202103010014', { defaultText: '保存成功' }));
                                this.$eventBus.$emit('closeTag', this.$route);
                                this.$router.go(-1);
                                this.saveBlock = false;
                                this.sendArray.length = 0;
                            }
                        }).catch(() => {
                            this.saveBlock = false;
                            this.sendArray.length = 0;
                        });
                    } else {
                        return false;
                    }
                });
            } else if (this.checkNames === false) {
                this.$message.warning(this.$translate('lang.EXC202103010013', { defaultText: '属性名称不能为空' }));
                this.checkNames = true;
            } else {
                this.$message.warning(this.$translate('lang.EXC202103010012', { defaultText: '图片/视频属性值只允许添加一条' }));
                this.checkNames = true;
            }
        },
        // 获取初始数据
        getFirst() {
            templateDetails({ id: this.$route.query.id }).then(res => {
                this.main.id = res.data.id;
                this.main.templateCode = res.data.templateCode;
                this.main.templateName = res.data.templateName;
                this.main.templateDescription = res.data.templateDescription;
                this.main.status = res.data.status;
                this.main.version = res.data.version;
                var arr = [];
                this.screenCutPicture(res.data.attributeList);

                res.data.attributeList.forEach(function(item) {
                    arr.push({
                        id: item.id,
                        version: item.version,
                        attributeName: item.attributeName,
                        attributeType: (item.attributeType).toString(),
                        required: item.required,
                        effect: item.effect,
                        display: item.display,
                        attributeValue: item.attributeValue,
                        showPicture: item.showPicture
                    });
                });
                this.main.attributeList = arr;
            });
        }
    },
    components: {
        Paper,
        UploadPlayer,
        uploadPictures
    },
    created() {
        this.tenantCode = this.currentTenant.tenantCode;
        if (this.$route.query.id) {
            this.id = this.$route.query.id;
            this.getFirst();
        } else {
            this.canCheck = false;
            this.newDefaultPush();
        }
    },
    activated() {
        this.tenantCode = this.currentTenant.tenantCode;
        if (this.$route.query.id) {
            this.canCheck = true;
            if (this.id !== this.$route.query.id) {
                this.getFirst();
                this.id = this.$route.query.id;
            }
        } else {
            this.canCheck = false;
            Object.keys(this.main).forEach(key => {
                this.main[key] = this.copyMain[key];
            });
            this.main.attributeList.length = 0;
            this.newDefaultPush();
        }
    },
    deactivated() {
        this.$refs.publicProperty.clearValidate();
    }
};